module.exports = __webpack_public_path__ + "static/media/yuce002.aa341547.jpg";